import React from 'react';
import { Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: '#6F9CEB !important',
    color: '#fff !important',
    fontSize: '0.875rem',
  },
  arrow: {
    color: '#6F9CEB !important',
  },
  circle: {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    display: 'inline-block',
    cursor: 'pointer',
    margin: '0 auto',
  },
});

const GeolocationStatusIndicator = ({ status }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const getStatusConfig = (status) => {
    switch (status) {
      case 'manual':
        return {
          color: '#4CAF50',
          tooltip: t('Customer ok')
        };
      case 'auto':
        return {
          color: '#FFC107',
          tooltip: t('Check and verify customer data')
        };
      case 'error':
        return {
          color: '#F44336',
          tooltip: t('Customer has issues pls verify customer data')
        };
      default:
        return {
          color: '#9E9E9E',
          tooltip: t(status)
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <div className={classes.container}>
      <Tooltip
        title={config.tooltip}
        arrow
        classes={{
          tooltip: classes.tooltip,
          arrow: classes.arrow,
        }}
      >
        <div
          className={classes.circle}
          style={{
            backgroundColor: config.color,
          }}
        />
      </Tooltip>
    </div>
  );
};

export default GeolocationStatusIndicator;
